import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd-mobile'

const SelectorButton = props => <Button size={'small'} {...props} />

const Selector = ({ value, onAdd, onSubtract }) => {
  return <div>
    <SelectorButton onClick={onSubtract}>-</SelectorButton>&emsp;
    {value}&emsp;
    <SelectorButton onClick={onAdd}>+</SelectorButton>
  </div>
}

class AmountSelector extends React.PureComponent {
  static defaultProps = {
    step: 1,
    min: 1
  }
  static propTypes = {
    defaultValue: PropTypes.number,
    max: PropTypes.number,
    min: PropTypes.number,
    value: PropTypes.number,
    step: PropTypes.number,
    onChange: PropTypes.func
  }

  static getDerivedStateFromProps (nextProps, state) {
    if (nextProps.value !== undefined && state.value !== nextProps.value) {
      const { value: _value, defaultValue } = nextProps
      return {
        controlled: _value !== undefined,
        value: _value || defaultValue || 0
      }
    }
    return null
  }

  state = {
    controlled: this.props.value !== undefined,
    value: this.props.value || this.props.defaultValue || 0
  }

  render () {
    const { value } = this.state
    return <Selector value={value} onAdd={this.add} onSubtract={this.subtract}/>

  }

  add = () => {
    const { value, controlled } = this.state
    const { step, onChange, max } = this.props
    if (max && max === value) return
    const newValue = value + step
    onChange && onChange(newValue)
    !controlled && this.setState({
      value: newValue
    })
  }

  subtract = () => {
    const { value, controlled } = this.state
    const { step, onChange, min } = this.props
    if (value > min) {
      const newValue = value - step
      onChange && onChange(newValue)
      !controlled && this.setState({
        value: newValue
      })
    }
  }
}

export { AmountSelector }
